/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import LogonHelper from '@/helper/LogonHelper'

// Routes
import paths from './paths'

function route (path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta: meta,
    component: (resolve) => import(
      `@/views/${view}.vue`
    ).then(resolve)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.meta)).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  LogonHelper.refresh()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    LogonHelper.check()
      .then(logged => {
        if (!logged || !store.state.isLogged) {
          store.dispatch('logout')
        }

        if (to.name === 'Login' && store.state.isLogged) {
          next('/')
        }
      })
      .catch(() => store.dispatch('logout'))
  }

  // Apply filter from local storage.
  store.dispatch('filters/applyFilter', {
    startDate: localStorage.getItem('filter.start_date'),
    endDate: localStorage.getItem('filter.end_date')
  })

  next()
})

export default router
